import { createContext, use } from 'react';

export type ModuleFilterContextValue = {
	handleAddModuleFilter: (moduleReferenceDesignator: string) => void;
};

export const ModuleFilterContext = createContext<ModuleFilterContextValue | null>(null);

/**
 * Hook to access the module filter context.
 * This context is only available on the analysis results page.
 *
 * @returns The module filter context value, or undefined if not on the analysis results page
 */
export function useModuleFilterContext(): ModuleFilterContextValue | undefined {
	const value = use(ModuleFilterContext);
	return value ?? undefined;
}

